import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ac0012',
    ecrans: ['00-2']
});

